import styled from 'styled-components';

import { ContentNode, Message, MessageType, TestableComponentProps } from '@dreryk/react-components';

const StyledPrescriptionStatus = styled(Message)`
   white-space: break-spaces;
`;

StyledPrescriptionStatus.displayName = 'StyledPrescriptionStatus';

type PrescriptionStatusProps = TestableComponentProps & {
   readonly type: MessageType;
   readonly label: ContentNode;
};

export const PrescriptionStatus = (props: PrescriptionStatusProps): JSX.Element => {
   return (
      <StyledPrescriptionStatus
         type={props.type}
         fullWidth
         displayIndicator
         label={props.label}
         testId={props.testId}
      />
   );
};
